import { Button, Checkbox, Form, Input, Space, Tabs } from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useState } from "react";
import { IconMailFilled, IconLockFilled, IconWand } from "@tabler/icons-react";
// import Logger from "../../utils/logger";
import appColors from "../../theme/common/colors";
import appAssets from "../../constants/assets";
import { motion } from "framer-motion";
import { useAuth } from "../../store";
// import { RoleTypes } from "../../../types";
import { useMutation } from "@tanstack/react-query";
import authApis from "../../api/methods/auth";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/exportClient";
import apiEndpoints from "../../api/endpoints";
// import { config } from "../../../config";
// import { getDevCredentials } from "../../utils/developmentUtils";
import AuthDebugger from "../../utils/authDebugger";
const LoginPage: React.FC = () => {
  const [form] = useForm();
  const [magicLinkForm] = useForm();
  const [activeTab, setActiveTab] = useState("1");
  const afterLogin = useAuth((state) => state.afterLogin);
  const navigate = useNavigate();

  const { mutate: logIn, isPending } = useMutation({
    mutationKey: authApis().login.mutationKey,
    mutationFn: authApis().login.mutationFn,
  });

  const { mutate: requestMagicLink, isPending: isMagicLinkPending } =
    useMutation({
      mutationKey: authApis().magicLinkRequest.mutationKey,
      mutationFn: authApis().magicLinkRequest.mutationFn,
    });

  // const fillFormWithRole = (role: RoleTypes) => {
  //   const credentials = getDevCredentials(role);
  //   if (credentials) {
  //     form.setFieldsValue(credentials);
  //   } else {
  //     Logger.warn("Development credentials not available for role:", role);
  //   }
  // };

  const handleLogin = async (values: any) => {
    logIn(values, {
      onSuccess: async (data) => {
        const token = data?.data?.token?.access;
        const refresh = data?.data?.token?.refresh;

        // Debug login data
        if (process.env.NODE_ENV === "development") {
          AuthDebugger.debugLoginSuccess(
            token,
            data?.data?.user_role,
            data?.data,
          );
          console.log(
            "🔐 Login Response - Capabilities:",
            data?.data?.capabilities,
          );
          console.log(
            "🔐 Login Response - Advance Capabilities:",
            data?.data?.advance_capabilities,
          );
        }

        const response = await apiClient.get(apiEndpoints.users.getProfile, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response?.status === 200) {
          if (data?.data?.user_role === "AttandanceCoordinator") {
            const coordinatorProfile = await apiClient.get(
              apiEndpoints.users.getCoordindatorProfile,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );
            if (response?.status === 200) {
              afterLogin(
                token,
                refresh,
                data?.data?.user_role,
                response?.data,
                coordinatorProfile?.data["Related Data"],
                data?.data?.capabilities || [],
                data?.data?.advance_capabilities || false,
              );
              navigate("/");
            }
          } else {
            afterLogin(
              token,
              refresh,
              data?.data?.user_role,
              response?.data,
              null,
              data?.data?.capabilities || [],
              data?.data?.advance_capabilities || false,
            );
            navigate("/");
          }
        } else {
        }
      },
      onError: () => {},
    });
  };

  const handleMagicLinkRequest = async (values: any) => {
    requestMagicLink(values, {
      onSuccess: () => {
        magicLinkForm.resetFields();
      },
      onError: () => {},
    });
  };

  return (
    <motion.div
      className="box"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1,
        delay: 0,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className="flex h-screen items-center justify-center p-4">
        <div
          style={{
            borderRadius: "20px",
          }}
          className="z-10 flex w-full max-w-4xl m-auto overflow-hidden bg-white"
        >
          <div className="flex items-center w-full lg:w-1/2 p-8">
            <div className="flex flex-col gap-2 w-full">
              <div className="m-auto mb-3 flex flex-row items-center justify-center">
                <img className="h-20" src={appAssets.common.logo} alt="" />
              </div>
              <div className="text-center pb-2">
                <p className="text-lg font-regular text-center text-slate-500">
                  Welcome Back,
                </p>
                {/* <p className="text-xl text- mb-2 font-semibold text-center text-slate-600">
                  EdConnex
                </p> */}
              </div>

              <div className="mt-4">
                <Tabs
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  centered
                  items={[
                    {
                      key: "1",
                      label: "Email & Password",
                      children: (
                        <Form
                          form={form}
                          layout="vertical"
                          onFinish={handleLogin}
                        >
                          <Space direction="vertical" className="w-full">
                            <Form.Item
                              name="email"
                              label="Email"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter your email",
                                },
                                {
                                  type: "email",
                                  message: "Please enter a valid email",
                                },
                              ]}
                            >
                              <Input
                                prefix={
                                  <IconMailFilled
                                    size={24}
                                    fill={appColors.primary}
                                  />
                                }
                                size="large"
                                placeholder="Email"
                              />
                            </Form.Item>
                            <Form.Item
                              label="Password"
                              className="mt-1"
                              name="password"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter your password",
                                },
                              ]}
                            >
                              <Input.Password
                                prefix={
                                  <IconLockFilled
                                    size={24}
                                    fill={appColors.primary}
                                  />
                                }
                                size="large"
                                placeholder="Password"
                              />
                            </Form.Item>
                            <Form.Item
                              name="remember"
                              valuePropName="checked"
                              initialValue={true}
                            >
                              <Checkbox>Remember me</Checkbox>
                            </Form.Item>
                            <Button
                              loading={isPending}
                              htmlType="submit"
                              type="primary"
                              size="large"
                              className="w-full mt-1"
                            >
                              Log In
                            </Button>
                          </Space>
                        </Form>
                      ),
                    },
                    {
                      key: "2",
                      label: (
                        <span className="flex items-center gap-2">
                          <IconWand size={16} />
                          Magic Link
                        </span>
                      ),
                      children: (
                        <Form
                          form={magicLinkForm}
                          layout="vertical"
                          onFinish={handleMagicLinkRequest}
                        >
                          <Space direction="vertical" className="w-full">
                            <Form.Item
                              name="email"
                              label="Email"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter your email",
                                },
                                {
                                  type: "email",
                                  message: "Please enter a valid email",
                                },
                              ]}
                            >
                              <Input
                                prefix={
                                  <IconMailFilled
                                    size={24}
                                    fill={appColors.primary}
                                  />
                                }
                                size="large"
                                placeholder="Email"
                              />
                            </Form.Item>
                            <div className="text-center mb-4">
                              <p className="text-sm text-slate-500">
                                Enter your email and we'll send you a secure
                                login link
                              </p>
                            </div>
                            <Button
                              loading={isMagicLinkPending}
                              htmlType="submit"
                              type="primary"
                              size="large"
                              className="w-full mt-1"
                            >
                              Send Magic Link
                            </Button>
                          </Space>
                        </Form>
                      ),
                    },
                  ]}
                />

                {/* <p className="mt-3 text-sm text-center text-slate-500">
                  Don't have an account?{" "}
                  <a
                    onClick={() => {}}
                    className="text-primary cursor-pointer font-bold focus:outline-none focus:underline hover:underline"
                  >
                    Register
                  </a>
                </p> */}
                {/* {config.enableRoleSelector && activeTab === "1" && (
                  <div className="flex flex-wrap gap-2 justify-center w-full mt-6">
                    {[
                      "Super_Admin",
                      "LEA_Admin",
                      "School_Admin",
                      "Parent",
                      "Teacher",
                      "Student",
                      "AttandanceCoordinator",
                    ].map((role) => (
                      <Button
                        size="small"
                        key={role}
                        onClick={() => fillFormWithRole(role as RoleTypes)}
                      >
                        {role === "AttandanceCoordinator"
                          ? "Attendance coordinator"
                          : role.replace("_", " ")}
                      </Button>
                    ))}
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div
            className="hidden lg:flex flex-col bg-cover lg:w-1/2 items-center justify-center"
            style={{
              margin: "8px",
              marginLeft: "32px",
              borderRadius: "16px",
              backgroundImage: `url(https://img.freepik.com/free-photo/view-3d-school-bus_23-2151103702.jpg?t=st=1734029037~exp=1734032637~hmac=ef4a4fd49708e31a477f9fdf79ab8156bd06f23f7705ade0fc25562ece1d09ce&w=1060)`,
            }}
          ></div>
          <div className="mt-4"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default LoginPage;
